import { FC } from 'react';
import { usePaymentContext } from '../../store/payments/payments-context';

interface Props {
  onSelectProvider: (provider: string) => void;
}
export const SelectProviderModal: FC<Props> = ({ onSelectProvider }) => {

  const { paymentContextState: { paymentGatewayRegisterList }} = usePaymentContext();


  return (
    <div className="row ps-5 pe-10 pb-5">
      {
        paymentGatewayRegisterList?.map(({ name, logoIcon }, index) => (
          <div key={index} className="col-3">
            <div
              className="provider-logo-box mb-5 ms-5 px-3"
              onClick={(): void => onSelectProvider(name)}
            >
              {
                logoIcon
                  ? (
                    <img
                      src={logoIcon}
                      alt={name}
                      className="provider-selector-logo"
                    />
                  ): name
              }
            </div>
          </div>
        ))
      }
    </div>
  );
};